<template>
  <div>
    <el-dialog
      title="物流信息"
      @close="onClose"
      :close-on-click-modal="false"
      :visible="dialogFormVisible"
      width="986px"
    >
      <el-form :model="queryParams" ref="logFromRefs" label-width="124px" style="padding:0 26px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="物流单号：" prop="logicNumber" :rules="filter_rules({required:true})">
              <el-input
                v-model="queryParams.logicNumber"
                ref="logicNumber"
                :disabled="type===2"
                @blur="onBlur"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="物流公司：" prop="logicCompany" :rules="filter_rules({required:true})">
              <el-input v-model="queryParams.logicCompany" :disabled="type===2"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="寄件时间：" prop="deliveryDate" :rules="filter_rules({required:true})">
              <el-date-picker
                :disabled="type===2"
                v-model="queryParams.deliveryDate"
                style="width:100%"
                type="datetime"
                placeholder="选择日期"
                format="yyyy-MM-dd hh:mm"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="承担人："
              prop="bearUser"
              :rules="filter_rules({required:true,type:'change'})"
            >
              <el-select v-model="queryParams.bearUser" :disabled="type===2">
                <el-option
                  v-for="(item,index) in selectList"
                  :key="index"
                  :label="item.staffCnName"
                  :value="item.staffCnName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="寄件人：">
              <el-input v-model="queryParams.deliveryPeople" :disabled="type===2"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="寄件人电话：">
              <el-input @input.native="onInput" v-model="queryParams.deliveryPhone" :disabled="type===2"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="寄件地址：">
              <el-input v-model="queryParams.deliveryAddress" :disabled="type===2"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="收件人：">
              <el-input v-model="queryParams.receivePeople" :disabled="type===2"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="收件人电话：">
              <el-input @input.native="onInput" v-model="queryParams.receivePhone" :disabled="type===2"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="收件地址：">
              <el-input v-model="queryParams.receiveAddress" :disabled="type===2"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="结算重量：" prop="weight" :rules="filter_rules({required:true})">
              <el-input-number
                style="width:150px"
                :min="1"
                :precision="2"
                :controls="false"
                v-model="queryParams.weight"
              ></el-input-number>&nbsp;kg
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="总体积：">
              <el-input-number
                style="width:150px"
                :min="1"
                :precision="2"
                :controls="false"
                v-model="queryParams.totalVolume"
              ></el-input-number>&nbsp;m³
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="总件数：">
              <el-input v-model="queryParams.total" oninput="value=value.replace(/\D|^0/g,'')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="包装：">
              <el-input v-model="queryParams.packing"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="保价金额：">
              <el-input-number
                style="width:100%"
                :min="0"
                :precision="2"
                :controls="false"
                v-model="queryParams.insuredLogisticsCost"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="运输方式：">
              <el-input v-model="queryParams.transportType"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="物流费用付款方："
              prop="expensePayer"
              :rules="filter_rules({required:true,type:'change'})"
            >
              <el-select v-model="queryParams.expensePayer">
                <el-option label="寄件人" value="寄件人"></el-option>
                <el-option label="收件人" value="收件人"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="物流费用：" prop="logisticsCost" :rules="filter_rules({required:true})">
              <el-input-number
                style="width:100%"
                :min="0"
                :precision="2"
                :controls="false"
                v-model="queryParams.logisticsCost"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="addsure">确 定</el-button>
        <el-button @click="onClose">取 消</el-button>
      </div>
    </el-dialog>
    <open-or-close
      ref="OpenOrCloseRefs"
      @onUpdataState="onUpdataState"
      title="提示"
      content="信息上传后将不可更改，是否确认？"
    ></open-or-close>
  </div>
</template>

<script>
import OpenOrClose from '@/components/OpenOrClose/index'
import {
  addLog,
  updateByIdLog,
  queryById,
  isItRedundant
} from '@/api/fiance/fianceManage'

export default {
  props: ['selectList'],
  components: {
    OpenOrClose
  },
  data() {
    return {
      dialogFormVisible: false,
      type: 0, // 1 新增 2 填写 3 查看
      queryParams: {}
    }
  },
  methods: {
    onInput(e) {
      // 过滤非数字和符号
      const regName = /^[\d-]+$/
      if (!regName.test(e.target.value)) {
        e.target.value = ''
      } else {
        return true
      }
    },
    onBlur() {
      if (this.queryParams.logicNumber) {
        isItRedundant(this.queryParams.logicNumber).then((res) => {
          if (res.data.code === 200) {
            if (res.data.obj) {
              this.$message.success('验证通过')
            } else {
              this.$message.error('物流单号不可重复')
              this.$refs.logicNumber.focus()
            }
          }
        })
      }
    },
    onClose() {
      this.$refs.logFromRefs.resetFields()
      this.dialogFormVisible = false
    },
    init(type, row) {
      this.type = type
      if (type === 1) {
        this.queryParams = {}
      } else {
        queryById(row.id).then((res) => {
          if (res.data.code === 200) {
            if (res.data.obj.expensePayer === null) {
              delete res.data.obj.expensePayer
            }
            this.queryParams = Object.assign({}, res.data.obj)
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }
      this.dialogFormVisible = true
    },
    addsure() {
      this.$refs.logFromRefs.validate((valid) => {
        if (valid) {
          this.$refs.OpenOrCloseRefs.onInitial()
        }
      })
    },
    onUpdataState() {
      if (this.type === 1) {
        addLog(this.queryParams).then((res) => {
          if (res.data.code === 200) {
            this.dialogFormVisible = false
            this.$emit('onInit')
          } else {
            this.$message.error(res.data.msg)
          }
        })
      } else if (this.type === 2) {
        updateByIdLog(this.queryParams).then((res) => {
          if (res.data.code === 200) {
            this.dialogFormVisible = false
            this.$emit('onInit')
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }
    }
  }
}
</script>
